import { CheckCircle } from 'lucide-react'

import type { EInvoice } from '@/lib/api/einvoice-api'
import { Badge } from '@/components/ui/badge'
import { m } from '@/lib/paraglide/messages'

export function EInvoiceIssuedPanel({ invoice }: { invoice: EInvoice }) {
    const invNo = invoice.inv_no ?? invoice.invoice_number
    return (
        <div className="space-y-2 rounded-md border border-green-200 bg-green-50 p-3">
            <div className="flex items-center gap-2 text-sm font-medium text-green-800">
                <CheckCircle className="size-4" />
                {m.einvoice_issued()} {invNo && `#${invNo}`}
            </div>
            {invoice.amount_mismatch ? (
                <Badge variant="destructive">
                    {m.einvoice_amount_mismatch()}
                </Badge>
            ) : null}
        </div>
    )
}
